/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { withAuth } from '@/components/hoc/withAuth';
import { AdminLayout } from '@/components/layout/AdminLayout';
import AdminDefaultLayout from '@/components/layout/AdminLayout/AdminDefaultLayout';
import { Loader } from '@/components/layout/DefaultLayout';
import { ROUTES } from '@/types/routes';
import { FC, lazy } from 'react';
import AdminProfile from './admin/profile';
import { AdminFranchisesDetailedPage } from './admin/franchisers';

const AdminDashboard = lazy<FC>(() => import('./admin/dashboard'));

const AdminBookings = lazy<FC>(() => import('./admin/bookings'));
const AdminPayments = lazy<FC>(() => import('./admin/payments'));
const AdminPromotions = lazy<FC>(() => import('./admin/promotions'));
const AdminApiKeys = lazy<FC>(() => import('./admin/api-keys'));
const AdminBrandNames = lazy<FC>(() => import('./admin/brand-names'));
const AdminConsultants = lazy<FC>(
  () => import('./admin/consultants/TablePage'),
);
const AdminConsultantsDetailedPage = lazy<FC>(
  () => import('./admin/consultants/DetailedPage'),
);
const AdminBookingsDetailedPage = lazy<FC>(
  () => import('./admin/bookings/DetailedPage'),
);
const AdminFranchises = lazy<FC>(() => import('./admin/franchisers/TablePage'));
const EditDetailsPageConsultant = lazy<FC>(
  () => import('./admin/consultants/EditDatailsPage'),
);
const EditDetailsPageFranchisor = lazy<FC>(
  () => import('./admin/franchisers/EditDetailsPage'),
);
const CreateDetailsPageFranchisor = lazy<FC>(
  () => import('./admin/franchisers/CreateDetailsPage'),
);
const CreateDetailsPageConsultant = lazy<FC>(
  () => import('./admin/consultants/CreateDetailsPage'),
);
const AdminFreeListing = lazy<FC>(() => import('./admin/free-listing'));

export const AdminRoutes = {
  Component: AdminLayout,
  loader: () => <Loader spinning />,
  children: [
    {
      Component: withAuth(AdminDefaultLayout),
      loader: () => <Loader spinning />,
      children: [
        {
          Component: AdminProfile,
          path: ROUTES.ADMIN_PROFILE,
          index: true,
        },
        {
          Component: AdminDashboard,
          path: ROUTES.ADMIN_DASHBOARD,
          index: true,
        },
        {
          Component: AdminBookings,
          path: ROUTES.ADMIN_BOOKINGS,
          index: true,
        },
        {
          Component: AdminPayments,
          path: ROUTES.ADMIN_PAYMENTS,
          index: true,
        },
        {
          Component: AdminConsultants,
          path: ROUTES.ADMIN_CONSULTANTS,
          index: true,
        },
        {
          Component: AdminPromotions,
          path: ROUTES.ADMIN_PROMOTIONS,
          index: true,
        },
        {
          Component: AdminApiKeys,
          path: ROUTES.ADMIN_API_KEYS,
          index: true,
        },
        {
          Component: AdminConsultantsDetailedPage,
          path: ROUTES.ADMIN_CONSULTANTS_DETAILED_PAGE,
          index: true,
        },
        {
          Component: AdminFranchisesDetailedPage,
          path: ROUTES.ADMIN_FRANCHISES_DETAILED_PAGE,
          index: true,
        },
        {
          Component: AdminBookingsDetailedPage,
          path: ROUTES.ADMIN_BOOKINGS_DETAILED_PAGE,
          index: true,
        },
        {
          Component: AdminFranchises,
          path: ROUTES.ADMIN_FRANCHISES,
          index: true,
        },
        {
          Component: AdminBrandNames,
          path: ROUTES.ADMIN_BRAND_NAMES,
          index: true,
        },
        {
          Component: EditDetailsPageConsultant,
          path: ROUTES.ADMIN_CONSULTANTS_EDIT_DETAILS,
          index: true,
        },
        {
          Component: EditDetailsPageFranchisor,
          path: ROUTES.ADMIN_FRANCHISES_EDIT_DETAILS,
          index: true,
        },
        {
          Component: CreateDetailsPageFranchisor,
          path: ROUTES.ADMIN_FRANCHISES_CREATE_DETAILS,
          index: true,
        },
        {
          Component: CreateDetailsPageConsultant,
          path: ROUTES.ADMIN_CONSULTANTS_CREATE_DETAILS,
          index: true,
        },
        {
          Component: AdminFreeListing,
          path: ROUTES.ADMIN_FREE_LISTING,
          index: true,
        },
      ],
    },
  ],
};
